// extracted by mini-css-extract-plugin
export var explainable = "_jb-a";
export var printerCard = "_jb-1";
export var printerCardConfigured = "_jb-2";
export var printerCardError = "_jb-3";
export var printerCardsContainer = "_jb-0";
export var printerIcon = "_jb-8";
export var printerIconConfigured = "_jb-5";
export var printerIconContainer = "_jb-4";
export var printerIconError = "_jb-6";
export var printerIconUnconfigured = "_jb-7";
export var workstationsTableCard = "_jb-9";